import * as action from 'actions'
import {call, put} from 'redux-saga/effects'
import * as actNotif from 'actions/notifications'
import * as api from 'api/invoices'
import {invoicesPageRequest} from 'actions/reports/invoices'

/**
 * Fetch invoices from the server
 * @param {object} params
 * @returns {*} invoices from server, or false if the request fails
 */
export function * getInvoices (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getInvoices, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch receipt invoices info from the server
 * @param {object} params
 * @returns {*} receipt invoices info from server, or false if the request fails
 */
export function * getReceiptInvoices (id, params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getReceiptInvoices, id, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

export function * createRecordPayment (data) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.createRecordPayment, data)
    // refresh page
    yield put(invoicesPageRequest())
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

export function * resendEmail (invoiceId) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.resendEmail, invoiceId)
    return response
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}



// WEBPACK FOOTER //
// ./app/sagas/api/invoices.js